"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTimeout = exports.sleep = exports.Promises = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
const index_1 = require("./index");
let Promises = class Promises {
    static async sleep(seconds) {
        return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
    }
    static withTimeout(promise, ms) {
        let timeoutId;
        const timeoutPromise = new Promise((_, reject) => {
            timeoutId = setTimeout(() => {
                reject(new index_1.TimeoutError(`Promise timed out after [${ms}] ms`));
            }, ms);
        });
        return Promise.race([promise, timeoutPromise]).finally(() => {
            clearTimeout(timeoutId);
        });
    }
};
exports.Promises = Promises;
exports.Promises = Promises = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], Promises);
exports.sleep = Promises.sleep, exports.withTimeout = Promises.withTimeout;
//# sourceMappingURL=promises.js.map